import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
export const formatDateWTime = (d: string, withTime = true) => {
  const date = new Date(d);
  const dateTime = date.toLocaleDateString();
  const time = date.toLocaleTimeString();
  return `${dateTime} ${withTime ? `| ${time}` : ""} `;
};


export const noValidateDialCodes = ["992","993","995","49"]
